"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Instagram, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col md:flex-row gap-4 md:gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground/70 hover:text-primary transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="футър" className="bg-background border-t border-border py-6">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
            <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/ново–лого.webp" alt="Миш-Маш /интерпред/" className="!w-[127px] !h-[127px]" />
            <p className="text-sm text-muted-foreground">© 2026 Миш-Маш /интерпред/. Всички права запазени.<br /><br />Сайтът е изработен от "Сайтове За Теб"<br /><br /><br /></p>
          </div>

          {}
          <MenuProvider menu_id="18" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4">
            <Link to="https://www.facebook.com/share/1BW5mcC5Qv/" newTab className="text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-fast)] focus-ring" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}